import React from 'react';

// Default value is defined in PermissionsContextProvider
export const PermissionsContext = React.createContext({});
export * from './permissions';
